const messages = {
etax: {
    loadingTitle: 'กำลังตรวจสอบข้อมูล...',
    loadingDesc: 'โปรดรอสักครู่',

    title: 'รายละเอียดใบกำกับภาษี',

    issuedTitle: 'ออกใบกำกับภาษีแล้ว',
    issuedDesc: 'ไฟล์สามารถดาวน์โหลดได้ภายใน 7 วันหลังจากออกใบกำกับภาษี',

    success: 'สำเร็จ',

    fileName: 'ชื่อไฟล์',
    issueDate: 'วันที่ออกใบกำกับภาษี',
    expireDate: 'วันหมดอายุการดาวน์โหลด',

    download: 'ดาวน์โหลด PDF',
    expired: 'ลิงก์ดาวน์โหลดหมดอายุแล้ว',

    createTitle: 'ออกใบกำกับภาษีใหม่',
    editTitle: 'แก้ไขข้อมูลใบกำกับภาษี',

    unexpectedError: 'เกิดข้อผิดพลาดที่ไม่คาดคิด'
  }
}
export default messages